import { may, type CanHolder } from "../../lib/access";

/**
 * M-008 DSGVO affordances (ADR-API-09: the server re-checks every route),
 * answered by `/me.can` ([F-027]). Since V0.9.1 (PO-047 (A)) only the
 * DSGVO-Auditor reaches "Anfragen verwalten" - the admin role without it not
 * even reading ([F-024]).
 */

/** May see the "Anfragen verwalten" tab (`dsgvo.search`: search, occurrences, journal, review list). */
export function canManageDsgvoRequests(user: CanHolder | null | undefined): boolean {
  return may(user, "dsgvo.search");
}

/** May order erasures, run replays and work the manual review (`dsgvo.erase`). */
export function canOrderDeletion(user: CanHolder | null | undefined): boolean {
  return may(user, "dsgvo.erase");
}

/** May create an Auskunft im Auftrag (`dsgvo.disclosure`, [F-024] function 2). */
export function canCreateDisclosure(user: CanHolder | null | undefined): boolean {
  return may(user, "dsgvo.disclosure");
}
